/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementSliderDefaultIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementSliderDefaultIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M2.00001 3C2.00001 2.44772 2.44773 2 3.00001 2H13C13.5523 2 14 2.44772 14 3V4.02734H13V3H3.00001V4.02734H2.00001V3Z"
              fill="currentColor"
            />
            <path
              d="M3.00001 11.0273V13H13V11.0273H14V13C14 13.5523 13.5523 14 13 14H3.00001C2.44773 14 2.00001 13.5523 2.00001 13V11.0273H3.00001Z"
              fill="currentColor"
            />
            <path
              d="M13.7929 7.52734L11.6465 5.3809L12.3536 4.67379L15.2071 7.52734L12.3536 10.3809L11.6465 9.67379L13.7929 7.52734Z"
              fill="currentColor"
            />
            <path
              d="M4.35357 5.3809L2.20712 7.52734L4.35357 9.67379L3.64646 10.3809L0.792908 7.52734L3.64646 4.67379L4.35357 5.3809Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementSliderDefaultIcon.tags = [
  'slider',
  'arrows',
  'left',
  'right',
  'navigate',
  'switch',
];

ElementSliderDefaultIcon.category = 'Navigator';

ElementSliderDefaultIcon.iconSize = 16;
